import * as Sentry from "@sentry/react";
import { __DEV__, SENTRY_DSN } from "../env";

Sentry.init({
  environment: __DEV__ ? "development" : "production",
  dsn: SENTRY_DSN,
  release: "starflyia@0.6.10",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  tracesSampleRate: 0.5,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.browserProfilingIntegration(),
  ],
});
